import { useField } from 'formik';
import { TextFieldSize } from '@bechtel/gds';
import { LocationDescriptionStyled } from './styled';
import { ErrorField } from '~/components/atoms';
import { t } from '@lingui/macro';
export const LocationDescription = ({ name }) => {
  const [field, meta] = useField(name);
  return (
    <>
      <LocationDescriptionStyled
        maxLength={2000}
        {...field}
        placeholder={t`Location Description`}
        size={TextFieldSize.LARGE}
        rows="3"
      />
      {meta.touched && meta.error ? <ErrorField error={meta.error} /> : null}
    </>
  );
};
